const HINTS = [
  { keys: "↑↓", label: "navigate" },
  { keys: "↵", label: "select" },
  { keys: "esc", label: "close" },
] as const;

export function CommandPaletteFooter() {
  return (
    <div className="bg-surface-subtle flex items-center gap-4 border-t px-5 py-2">
      {HINTS.map(({ keys, label }) => (
        <div
          key={keys}
          className="text-action-disabled-content flex items-center gap-1 text-[11px]"
        >
          <kbd className="text-content-muted rounded border bg-white px-[5px] py-px text-[10px] font-medium">
            {keys}
          </kbd>
          <span>{label}</span>
        </div>
      ))}
    </div>
  );
}
